export class leadSubmissionLMPApi {

    private props: any;

    private handleLeadSubmission: any;

    constructor(local: any, handleLeadSubmission: (this: void) => any) {
        this.props = local;
        this.handleLeadSubmission = handleLeadSubmission;
    }
    getCookie(name: string | any[]) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURI(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
    async submitLead(bookAppointment = false) {
        var submissionModel;
        submissionModel = {
            "leadId": this.props.values.LeadId,
            "brand": "NAVL",
            "agentCode": this.props.values.agentCode,
            "calendarTitle": "",
            "calendarLocation": "",
            "CalendarAppointmentDate": this.props.values.appointmentDateString,
            "CalendarAppointmentTime": this.props.values.appointmentTimeString.split(" ")[0],
            "CalendarAppointmentTimeOfDay": this.props.values.appointmentTimeString.split(" ")[1],
            "CalendarDuration": "1 hour",
            "calendarUserName": "",
            "calendarSalesPersonId": "",
            "calendarDetail": "",
            "calendarURL": "",
            "allocationId": this.props.values.agentAllocationId,
            "originAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
            "originCity": this.props.values.movingFromAddrComponent.MovingFromCity,
            "originState": this.props.values.movingFromAddrComponent.MovingFromState,
            "originZipcode": this.props.values.movingFromAddrComponent.MovingFromZip,
            "__RequestVerificationToken": this.props.values.verificationToken
        };

        if (bookAppointment) {
            submissionModel = {
                "leadId": this.props.values.LeadId,
                "brand": "NAVL",
                "agentCode": this.props.values.agentCode,
                "calendarTitle": "",
                "calendarLocation": "",
                "CalendarAppointmentDate": this.props.values.appointmentDateString,
                "CalendarAppointmentTime": this.props.values.appointmentTimeString.split(" ")[0],
                "CalendarAppointmentTimeOfDay": this.props.values.appointmentTimeString.split(" ")[1],
                "CalendarDuration": "1 hour",
                "calendarUserName": "",
                "calendarSalesPersonId": "",
                "calendarDetail": "",
                "calendarURL": "",
                "allocationId": this.props.values.agentAllocationId,
                "originAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
                "originCity": this.props.values.movingFromAddrComponent.MovingFromCity,
                "originState": this.props.values.movingFromAddrComponent.MovingFromState,
                "originZipcode": this.props.values.movingFromAddrComponent.MovingFromZip,
                "__RequestVerificationToken": this.props.values.verificationToken

            };
        }
        console.log("****************Submission Model");
        console.log(JSON.stringify(submissionModel));

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'x-api-key': 'bJx8kYsEFRza88ELBb2Vt8SD2NzXjnPy',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(submissionModel)
            //body: new URLSearchParams(submissionModel)
        };
        console.log("Starting SubmitAppointment the API Call");
        //Call Instaquote API
        let apiSuccess = false;
        await fetch('/CustomApi/OnlineAppointmentBooking/SubmitAppointment', requestOptions)
            .then(response => {
                console.log("**************After Fetch RESPONSE**********************");
                console.log(JSON.stringify(response));
                if (!response.ok) {
                    throw new Error('error => Error while Submitting Lead')
                }
                return response.json();
            })
            .then((data) => {
                if (bookAppointment) {
                    console.log("******Return DATA*****");
                    console.log(JSON.stringify(data));
                    this.handleLeadSubmission(data);
                }
                apiSuccess = true;
            },
                (error) => {
                    if (bookAppointment) {
                        this.handleLeadSubmission(error);
                    }
                    apiSuccess = false;
                })
            .catch(error => {
                console.log(error);
            });

        return apiSuccess;
    }
}